import type * as THREE from 'three'
import type { GraphicsBackend } from '@/graphics/GraphicsBackend'
import { BackendMismatchError } from '@/graphics/GraphicsErrors'

/** 在对象上定义只在实际读取时解析的 legacy WebGL renderer。 */
export function defineLegacyRendererAccessor<T extends object>(
  target: T,
  graphics: GraphicsBackend,
  getRenderer: () => THREE.WebGLRenderer
): T & { readonly renderer: THREE.WebGLRenderer } {
  Object.defineProperty(target, 'renderer', {
    configurable: false,
    enumerable: true,
    get: () => {
      if (graphics.kind !== 'webgl2') {
        throw new BackendMismatchError('webgl2', graphics.kind, 'legacy renderer accessor')
      }
      return getRenderer()
    },
  })
  return target as T & { readonly renderer: THREE.WebGLRenderer }
}

/** 在 phase context 上定义只在实际读取时解析的 legacy WebGL outputTarget。 */
export function defineLegacyOutputTargetAccessor<T extends object>(
  target: T,
  graphics: GraphicsBackend,
  getOutputTarget: () => THREE.WebGLRenderTarget | null
): T & { readonly outputTarget: THREE.WebGLRenderTarget | null } {
  Object.defineProperty(target, 'outputTarget', {
    configurable: false,
    enumerable: true,
    get: () => {
      if (graphics.kind !== 'webgl2') {
        throw new BackendMismatchError('webgl2', graphics.kind, 'legacy outputTarget accessor')
      }
      return getOutputTarget()
    },
  })
  return target as T & { readonly outputTarget: THREE.WebGLRenderTarget | null }
}
